import { ORDER_STATUSES } from '../define/constants';

export const canShowPartnerInfo = (status) => {
  switch (status) {
    case ORDER_STATUSES.confirmedBooking:
    case ORDER_STATUSES.confirmedPostponed:
    case ORDER_STATUSES.confirmedSuspended:
    case ORDER_STATUSES.confirmedVoucher:
    case ORDER_STATUSES.completedBooking:
    case ORDER_STATUSES.completedVoucher:
      return true;
    default:
      return false;
  }
};
